import './components/blog_card';
import './components/call_to_action_bar';
import './components/card_with_image';
import './components/fdo_news';
import './components/highlight_card';
import './components/home_video';
import './components/others_section';
import './components/our_functionality';
import './components/testimonials';
import './components/youtube_banner';
import './index.scss';
import 'components/campaigns/interventions/products_hero/default';
import 'components/campaigns/interventions/products_hero/hero_lot';
import 'components/cms/render_component';
import 'components/contest_card';
import 'components/home_generic_card';
import 'components/how_to_study';
import 'components/our_numbers_bar';
import zaraz from 'utils/trackers/zaraz';

(() => {
  'use strict';

  const $container = $('[data-event]');
  const eventData = $container.data('event') || {};

  if ($container && eventData?.active) {
    zaraz.set('show_experiment', 'true', { scope: 'persist' });
    zaraz.track(eventData.event, eventData.event_props);
  }
})();
